<template>
  <div class="order-page pl-4">
    <div class="animated-bg">
      <div class="bg-shape shape-1"></div>
      <div class="bg-shape shape-2"></div>
      <div class="bg-shape shape-3"></div>
    </div>

    <div class="page-header">
      <div class="header-content px-2">
        <div class="d-flex">
          <h1>Detail Sales</h1>
          <div class="header-badge ml-2">
            <v-icon size="14" color="white">mdi-account-cash</v-icon>
            <span>Sales</span>
          </div>
        </div>
        <p>Informasi lengkap data sales, customer, target dan kunjungan</p>
      </div>
    </div>

    <div class="main-card detail-card">
      <v-card-text v-if="process.form" class="detail-loading">
        <div class="text-center">
          <div class="mb-2 title">Mohon Tunggu...</div>
          <v-progress-circular indeterminate color="#00ADB5"></v-progress-circular>
        </div>
      </v-card-text>

      <template v-if="!process.form && Object.keys(detail).length > 0">
        <div class="detail-hero">
          <div class="detail-hero-avatar">
            <v-img v-if="detail.image_url" :src="detail.image_url" contain aspect-ratio="1" class="rounded"></v-img>
            <div v-else class="detail-hero-avatar-placeholder">
              <v-icon size="48" color="#9ca3af">mdi-account</v-icon>
            </div>
          </div>
          <div class="detail-hero-info">
            <h2 class="detail-hero-name">{{ detail.name }}</h2>
            <div class="detail-hero-meta">
              <span class="detail-chip">{{ detail.category_user_title }}</span>
              <span class="detail-chip">{{ detail.branch_name }}</span>
              <span v-if="detail.code" class="detail-chip detail-chip-outline">Kode: {{ detail.code }}</span>
            </div>
          </div>
        </div>

        <div class="detail-body">
          <div class="detail-section mt-1">
            <v-tabs
              v-model="tabs"
              dense
              background-color="transparent"
              slider-size="5"
              color="#00ADB5">
              <v-tab
                v-for="(item, index) in tab"
                :key="index"
                @click="changeQuery(item.link)">
                <span class="body-2 font-weight-medium text-capitalize">{{ item.title }}</span>
              </v-tab>
            </v-tabs>
            <v-divider class="mt-2" style="border-color: #EBEEF2;"></v-divider>

            <div class="detail-tab-content pt-4">
              <Profile v-if="tabs === 0" :detail="detail" @update="fetchDetail()" />
              <Customer v-if="tabs === 1" :detail="detail" />
              <Target v-if="tabs === 2" :detail="detail" />
              <Kunjungan v-if="tabs === 3" :detail="detail" />
            </div>
          </div>

          <div class="detail-actions">
            <v-btn to="/sales/staff" :disabled="process.form" color="#00ADB5" class="white--text px-6" rounded elevation="0">
              <v-icon left>mdi-arrow-left</v-icon>
              Kembali
            </v-btn>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
  
<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        tabs: 0,
        tab: [
          {
            title: 'Detail',
            link: `/sales/staff/detail/${this.$route.params.id}?menu=detail`
          },
          {
            title: 'Customer',
            link: `/sales/staff/detail/${this.$route.params.id}?menu=customer`
          },
          {
            title: 'Target Sales',
            link: `/sales/staff/detail/${this.$route.params.id}?menu=target`
          },
          {
            title: 'Target Kunjungan',
            link: `/sales/staff/detail/${this.$route.params.id}?menu=kunjungan`
          },
        ],


        detail: {},

        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+93}, ${g+120}, ${b+12})`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },

      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },

      years () {
        let max = new Date().getFullYear()+2, min = max - 2, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    components: {
      Profile: () => import(/* webpackPrefetch: true */ '@/components/sales/profile.vue'),
      Customer: () => import(/* webpackPrefetch: true */ '@/components/sales/customer.vue'),
      Visit: () => import(/* webpackPrefetch: true */ '@/components/sales/visit.vue'),
      Target: () => import(/* webpackPrefetch: true */ '@/components/sales/target.vue'),
      Kunjungan: () => import(/* webpackPrefetch: true */ '@/components/sales/kunjungan.vue')
    },
    watch: {
      '$route.query.menu': function(val) {
        this.changeLink(val)
      }
    },
    mounted () {
      this.fetchDetail()
      this.changeLink(this.$route.query.menu)
    },
    methods: {
      async fetchDetail () {
        this.process.form = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/user/detail', { params })
          .then(response => {
            let res = response.data
            if (res.status === 200) {
              this.detail = res.results.data
            }
            this.process.form = false
          })
      },

      changeLink (query) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        
        if (query !== undefined) {
          this.tabs = query === 'detail' ? 0 : query === 'target' ? 2 : query === 'kunjungan' ? 3 : 1
        } else {
          this.tabs = 0
        this.$router.push(this.tab[this.tabs].link)
        }
      },
      changeQuery (link) {
        this.$router.push(link)
      },

      updateTime () {
        let cd = new Date()

        this.clock.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2) + ':' + this.zeroPadding(cd.getSeconds(), 2)
      },
      zeroPadding (num, digit) {
        let zero = ''

        for(let i = 0; i < digit; i++) {
          zero += '0'
        }
        return (zero + num).slice(-digit)
      }
    }
  }
</script>

<style scoped>
.order-page {
  position: relative;
  padding: 18px;
  padding-top: 36px;
  min-height: 100%;
  background: linear-gradient(180deg, #fcfcfc 0%, #f8fafa 100%);
}

.animated-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
}

.bg-shape {
  position: absolute;
  border-radius: 50%;
  opacity: 0.6;
  animation: float 20s ease-in-out infinite;
}

.shape-1 {
  width: 300px;
  height: 300px;
  background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
  top: -100px;
  right: -50px;
  filter: blur(60px);
  animation-delay: 0s;
}

.shape-2 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #FFD460 0%, #F07B3F 100%);
  bottom: 100px;
  left: -50px;
  filter: blur(50px);
  animation-delay: -5s;
}

.shape-3 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #EA5455 0%, #EA5455 100%);
  top: 50%;
  right: 20%;
  filter: blur(40px);
  animation-delay: -10s;
}

@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  25% { transform: translateY(-20px) rotate(5deg); }
  50% { transform: translateY(0) rotate(0deg); }
  75% { transform: translateY(20px) rotate(-5deg); }
}

.page-header {
  position: relative;
  z-index: 1;
  margin-bottom: 28px;
}

.header-content h1 {
  font-size: 18px;
  font-weight: 700;
  color: #222831;
  margin: 0 0 4px;
}

.header-content p {
  font-size: 14px;
  color: #393E46;
  margin: 0;
}

.header-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
  border-radius: 20px;
}

.header-badge span {
  font-size: 11px;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.main-card {
  position: relative;
  z-index: 1;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 30px rgba(34, 40, 49, 0.08);
  border: 1px solid rgba(238, 238, 238, 0.6);
  overflow: hidden;
}

.detail-loading {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-card {
  padding: 0;
}

.detail-hero {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 24px 24px 20px;
  border-bottom: 1px solid #f0f0f0;
  background: linear-gradient(180deg, #fafbfc 0%, #fff 100%);
}

.detail-hero-avatar {
  width: 72px;
  height: 72px;
  min-width: 72px;
  border-radius: 12px;
  overflow: hidden;
  background: #f1f3f4;
}

.detail-hero-avatar .v-img {
  width: 100%;
  height: 100%;
}

.detail-hero-avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-hero-info {
  flex: 1;
  min-width: 0;
}

.detail-hero-name {
  font-size: 20px;
  font-weight: 700;
  color: #222831;
  margin: 0 0 8px;
  line-height: 1.3;
}

.detail-hero-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.detail-chip {
  font-size: 12px;
  font-weight: 600;
  color: white;
  background: #00ADB5;
  padding: 4px 10px;
  border-radius: 6px;
}

.detail-chip-outline {
  background: transparent;
  color: #393E46;
  border: 1px solid #e8eaed;
}

.detail-body {
  padding: 0 24px 24px;
}

.detail-section {
  padding-top: 10px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.detail-section:last-of-type {
  border-bottom: none;
}

.detail-tab-content {
  min-height: 200px;
}

.detail-actions {
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
  margin-top: 8px;
  text-align: right;
}

@media (max-width: 600px) {
  .detail-hero {
    flex-direction: column;
    text-align: center;
  }
  .detail-hero-meta {
    justify-content: center;
  }
}
</style>